import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const TechnologiesPage = lazy(() => import('../pages/technologies/page'));
const IndustriesPage = lazy(() => import('../pages/industries/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const RequestFormPage = lazy(() => import('../pages/request-form/page'));
const ProductCategoryPage = lazy(() => import('../pages/product-category/page'));
const ProductDetailPage = lazy(() => import('../pages/product-detail/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/products/:partnerSlug/:categorySlug',
    element: <ProductCategoryPage />,
  },
  {
    path: '/products/:partnerSlug/:categorySlug/:productSlug',
    element: <ProductDetailPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/technologies',
    element: <TechnologiesPage />,
  },
  {
    path: '/industries',
    element: <IndustriesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/request-study',
    element: <RequestFormPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
